import {useBilling, useClient, useDictionary} from '@adamlip/okeoke.client';
import InvoiceAddresses from 'components/InvoiceAddresses';
import useBasket from 'hooks/useBasket';
import {useEffect, useContext} from 'react';
import {Checkbox} from '@heroui/react';
import {AppParamsContext} from 'contexts/AppParamsContext';

export default function InvoiceInfo() {
	const {getValue} = useDictionary();
	const {handleInvoiceNeeded, invoiceNeeded} = useBasket();

	const {features} = useClient();
	const {appParams} = useContext(AppParamsContext);
	const handleLoading = (e) => {};
	const {subscriptions} = useBilling();

	useEffect(() => {
		if (subscriptions?.brand?.['license.vatinvoice'] && appParams?.order?.forceInvoiceNeeded) {
			handleInvoiceNeeded(1);
		}
		// eslint-disable-next-line
	}, [appParams, features]);

	if (!subscriptions?.brand?.['license.vatinvoice']) return null;

	if (appParams?.basketModal?.visibleBlocks?.invoice == null || appParams?.basketModal?.visibleBlocks?.invoice === false) return null;

	return (
		<div className={`${appParams?.styles?.fonts?.capitalize ? 'font-extrabold uppercase' : ''}  flex flex-col `}>
			<p className='text-sm opacity-70'>{getValue('app_v2_invoiceAddress')}</p>
			<div className='invoice-needed items-center justify-between w-full flex mb-2'>
				{appParams?.order?.forceInvoiceNeeded && getValue('app_v2_basket_slider_invoice_needed_text')}
				{!appParams?.order?.forceInvoiceNeeded && (
					<>
						<Checkbox isSelected={invoiceNeeded === 1} onValueChange={() => handleInvoiceNeeded(invoiceNeeded === 1 ? 0 : 1)} size='lg'>
							<div className='w-full flex flex-col gap-0'>
								<div className='font-bold'>{getValue('app_v2_invoiceAddress_invoiceNeeded')}</div>
								<div className='text-xs opacity-70 bottom-[4px] relative'>{getValue('app_v2_invoiceAddress_invoiceNeeded_desc')}</div>
							</div>
						</Checkbox>
					</>
				)}
			</div>
			{invoiceNeeded === 1 && <InvoiceAddresses setAddressInOrder={true} handleLoading={handleLoading} />}
		</div>
	);
}
